(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-desktop-nav"] && !Shopify.designMode) return;
  try {
    document.getElementById('megaMenuClose').addEventListener('click', function() {
   let megaMenuMaster = document.getElementById ( "megaMenuMaster" ) ;
   megaMenuMaster.style.visibility = "hidden";
   setTimeout(function(){
     megaMenuMaster.style.visibility = "";
     console.log('anchor');
   },1000)
});
  } catch(e) { console.error(e); }
})();

})();
